import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import styles from './field.module.css';
import { Size } from '../../enums/size';
export function Field(Component, showLabel = true, preventLabelClick = true) {
    const handlePreventLabelClick = (event) => preventLabelClick && event.preventDefault();
    return (props) => {
        const { label, note, errorMessage = '', isValid: valid, fullWidth = false, hideNoteSpace = false } = props, componentProps = __rest(props, ["label", "note", "errorMessage", "isValid", "fullWidth", "hideNoteSpace"]);
        const WrapComponent = showLabel ? 'label' : 'span';
        const isSmall = componentProps.size !== Size.Large;
        const isValid = valid === true;
        const isError = valid === false;
        const renderNote = () => (React.createElement("span", { className: cn(styles.fieldNote, { [styles.error]: isError }), "data-test": isError ? 'error' : 'note' }, isError ? errorMessage : note));
        const Note = () => {
            if (!hideNoteSpace) {
                return renderNote();
            }
            if (errorMessage || note) {
                return renderNote();
            }
            return null;
        };
        return (React.createElement(WrapComponent, { className: cn(styles.field, { [styles.fullWidth]: fullWidth }), onClick: handlePreventLabelClick },
            showLabel && isSmall && label && React.createElement("span", { className: styles.fieldLabel }, label),
            React.createElement(Component, Object.assign({}, props, { label: label, isValid: isValid, isError: isError })),
            React.createElement(Note, null)));
    };
}
//# sourceMappingURL=field.js.map